import React from "react";
import "./App.css";
import { Route } from "react-router-dom";
import Header from "../src/Header";
import About from "./Components/AboutHomePage";
import Portfolio from "./Components/Portfolio";
import Contact from "./Components/Contact";

function App() {
  return (
    <>
      <Header />
      <Route exact path='/'>
        <About />
      </Route>

      <Route path='/portfolio'>
        <Portfolio />
      </Route>

      <Route path='/contact'>
        <Contact />
      </Route>
    </>
  );
}

export default App;
